module.exports = __webpack_public_path__ + "img/logo-cenova_mapa.c18f6cdb.svg";